import { Component } from '@angular/core';
import { membersuiteCancellationFeeProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Cancellation Fee Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuitecancellationfeeproduct-form',
    templateUrl: './membersuitecancellationfeeproduct.form.component.html'
})
export class membersuiteCancellationFeeProductFormComponent extends BaseFormComponent {
    public record!: membersuiteCancellationFeeProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

